import React from 'react';

export const UserInfo = ({ user }) => {
  if (!user) return null;

  return (
    <div className="user-info">
      <p>Welcome, {user.displayName || user.username || 'User'}!</p>
      <p>FID: {user.fid}</p>
    </div>
  );
}; 